(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/bank-card/bank-card.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/bank-card/bank-card.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const logger = svs.accountservicesReact.deposit.bankCard.logger;
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState,
  forwardRef = _React.forwardRef,
  useImperativeHandle = _React.useImperativeHandle;
const _svs$accountservicesR = svs.accountservicesReact.deposit.depositShared,
  OnboardingDepositAmountInfo = _svs$accountservicesR.OnboardingDepositAmountInfo,
  DepositButton = _svs$accountservicesR.DepositButton,
  DepositInput = _svs$accountservicesR.DepositInput,
  useSuccessCleanup = _svs$accountservicesR.useSuccessCleanup;
const Form = svs.ui.reactForm.Form;
const paymentTypes = svs.accountservicesReact.deposit.constants.paymentTypes;
const _svs$accountservicesR2 = svs.accountservicesReact.deposit.helpers.sharedHelpers,
  navigateOnPayTrue = _svs$accountservicesR2.navigateOnPayTrue,
  handleError = _svs$accountservicesR2.handleError;
const showDepositSuccess = svs.accountservicesReact.deposit.dialogs.sharedDialogs.showDepositSuccess;
const formatCurrencyAsJupiterString = svs.utils.format.CurrencyAsJupiterString;
const _svs$accountservicesR3 = svs.accountservicesReact.deposit.store.deposit.actions,
  amountChangeAction = _svs$accountservicesR3.amountChangeAction,
  updateSpendLimitRemainingAction = _svs$accountservicesR3.updateSpendLimitRemainingAction;
const SWEDBANKPAY_CONTAINER_ELEMENT = svs.accountservicesReact.deposit.constants.SWEDBANKPAY_CONTAINER_ELEMENT;
const BANKCARD_STATE = {
  INIT: 0,
  POLL: 1
};
let swedbankPayCheckout;
const formatAndDeposit = amount => {
  const transAmount = formatCurrencyAsJupiterString(amount);
  swedbankPayCheckout.deposit(transAmount, paymentTypes.BANKCARD);
};
const baseOptions = {
  el: SWEDBANKPAY_CONTAINER_ELEMENT,
  backButton: true,
  backButtonText: 'Tillbaka',
  backButtonCallback: () => {
    svs.components.analytics.trackEvent({
      category: 'Deposits',
      action: 'Deposit Cancel BackButton',
      opt_label: 'CC'
    });
  },
  prefixText: 'Betalningar',
  isNotInfoText: false,
  context: void 0
};
const BankCard = forwardRef((_ref, ref) => {
  let isPlayerRegistration = _ref.isPlayerRegistration,
    swedbankPayProps = _ref.swedbankPayProps;
  const dispatch = ReactRedux.useDispatch();
  const depositAmount = ReactRedux.useSelector(state => state.deposit.amount);
  const instantPay = ReactRedux.useSelector(state => state.deposit.instantPay);
  const returnUrl = ReactRedux.useSelector(state => state.deposit.returnUrl);
  const maxLimitLeft = ReactRedux.useSelector(state => {
    var _state$deposit$maxLim;
    return (_state$deposit$maxLim = state.deposit.maxLimits) === null || _state$deposit$maxLim === void 0 ? void 0 : _state$deposit$maxLim.spendLimitRemaining;
  });
  const _useState = useState(BANKCARD_STATE.INIT),
    _useState2 = _slicedToArray(_useState, 2),
    apState = _useState2[0],
    setApState = _useState2[1];
  const successCleanup = useSuccessCleanup();

  useImperativeHandle(ref, () => ({
    cleanUpSwedbankPayOnDropdownChange: () => {
      var _swedbankPayCheckout, _swedbankPayCheckout$;
      swedbankPayCheckout && ((_swedbankPayCheckout = swedbankPayCheckout) === null || _swedbankPayCheckout === void 0 || (_swedbankPayCheckout$ = _swedbankPayCheckout.cleanUpSwedbankPayTransaction) === null || _swedbankPayCheckout$ === void 0 ? void 0 : _swedbankPayCheckout$.call(_swedbankPayCheckout));
    }
  }));
  useEffect(() => {
    const hasInstantPayAmount = svs.accountservicesReact.deposit.helpers.sharedHelpers.hasInstantPayAmount;
    const prepareFn = () => setApState(BANKCARD_STATE.POLL);
    const cleanUpFn = () => {
      setApState(BANKCARD_STATE.INIT);
      window.scrollTo(0, 0);
    };
    const successFn = async successEventData => {
      logger.debug('payment success!', successEventData);
      setApState(BANKCARD_STATE.INIT);
      const accountBalance = await successCleanup({
        amount: successEventData.amount,
        accountBalance: successEventData.accountBalance
      });
      if (navigateOnPayTrue(returnUrl)) {
        return;
      }
      dispatch(updateSpendLimitRemainingAction(successEventData.amount));
      await showDepositSuccess({
        amount: successEventData.amount,
        accountBalance,
        paymentType: paymentTypes.BANKCARD
      }, returnUrl);
    };
    const errorFn = (err, transactionData) => {
      logger.debug(err, transactionData);
      handleError(err, paymentTypes.BANKCARD, transactionData, maxLimitLeft);
    };
    const options = _objectSpread(_objectSpread({}, baseOptions), {}, {
      prepareFn,
      cleanUpFn,
      successFn,
      errorFn
    });
    if ((swedbankPayProps === null || swedbankPayProps === void 0 ? void 0 : swedbankPayProps.hasBackButton) !== undefined) {
      options.backButton = swedbankPayProps === null || swedbankPayProps === void 0 ? void 0 : swedbankPayProps.hasBackButton;
    }
    if (typeof (swedbankPayProps === null || swedbankPayProps === void 0 ? void 0 : swedbankPayProps.backButtonText) === 'string' && (swedbankPayProps === null || swedbankPayProps === void 0 ? void 0 : swedbankPayProps.backButtonText.length) > 0) {
      options.backButtonText = swedbankPayProps === null || swedbankPayProps === void 0 ? void 0 : swedbankPayProps.backButtonText;
    }
    swedbankPayCheckout = new svs.accountservices.swedbankpay_checkout.SwedbankPayCheckout(options);
    if (instantPay !== null && instantPay !== void 0 && instantPay.isPay) {
      formatAndDeposit(instantPay.amount);
    } else if (hasInstantPayAmount(instantPay)) {
      dispatch(amountChangeAction(instantPay === null || instantPay === void 0 ? void 0 : instantPay.amount));
    }
  }, [dispatch, instantPay, returnUrl, swedbankPayProps === null || swedbankPayProps === void 0 ? void 0 : swedbankPayProps.backButtonText, swedbankPayProps === null || swedbankPayProps === void 0 ? void 0 : swedbankPayProps.hasBackButton, successCleanup, maxLimitLeft]);
  const handleSubmit = (e, isValid) => {
    e.preventDefault();
    if (!isValid) {
      return;
    }
    formatAndDeposit(depositAmount);
  };
  return React.createElement("div", null, React.createElement(Form, {
    method: "post",
    onSubmit: (e, _formData, isValid) => {
      handleSubmit(e, isValid);
    }
  }, apState === BANKCARD_STATE.INIT && React.createElement(React.Fragment, null, React.createElement(DepositInput, null), isPlayerRegistration && React.createElement(OnboardingDepositAmountInfo, {
    depositAmount: depositAmount
  }), React.createElement(DepositButton, null)), React.createElement("div", {
    className: SWEDBANKPAY_CONTAINER_ELEMENT
  })));
});
svs.accountservicesReact.deposit.bankCard.BankCard = BankCard;

 })(window);